import { useThemeTokens } from '@providers/themeTokenProvider';

export type BadgeTokens = {
  badge: {
    number?: {
      backgroundColor?: string;
      textColor?: string;
      borderRadius?: string;
      borderColor?: string;
      borderStyle?: string;
      borderWidth?: string;
    };
    text?: {
      borderRadius?: string;
      borderStyle?: string;
      borderWidth?: string;
      neutral?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      positive?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      warning?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      negative?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      gray?: {
        backgroundColor?: string;
        textColor?: string;
      };
      supportOne?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      supportTwo?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      supportThree?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      supportFour?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      supportFive?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
      supportSix?: {
        backgroundColor?: string;
        textColor?: string;
        borderColor?: string;
      };
    };
  };
};

export const useBadgeTokens = (): BadgeTokens => {
  const baseTokens = useThemeTokens();
  const { sys } = baseTokens;
  const comp: BadgeTokens = {
    badge: {
      number: {
        backgroundColor: sys.color.negative,
        textColor: sys.color.onNegative,
        borderRadius: '100px',
        borderStyle: 'none',
        borderWidth: '1px',
        borderColor: sys.color.negative,
      },
      text: {
        borderRadius: sys.borderRadius.sm,
        borderStyle: 'none',
        borderWidth: '1px',
        neutral: {
          backgroundColor: sys.color.supportOneVariant,
          textColor: sys.color.supportOneOnVariant,
          borderColor: sys.color.supportOneVariant,
        },
        positive: {
          backgroundColor: sys.color.positiveVariant,
          textColor: sys.color.onPositiveVariant,
          borderColor: sys.color.positiveVariant,
        },
        warning: {
          backgroundColor: sys.color.warningVariant,
          textColor: sys.color.onWarningVariant,
          borderColor: sys.color.warningVariant,
        },
        negative: {
          backgroundColor: sys.color.negativeVariant,
          textColor: sys.color.onNegativeVariant,
          borderColor: sys.color.negativeVariant,
        },
        gray: {
          backgroundColor: sys.color.surfaceContainer,
          textColor: sys.color.onSurface,
        },
        supportOne: {
          backgroundColor: sys.color.supportOneNewVariant,
          textColor: sys.color.supportOneOnNewVariant,
          borderColor: sys.color.supportOneNewVariant,
        },
        supportTwo: {
          backgroundColor: sys.color.supportTwoVariant,
          textColor: sys.color.supportTwoOnVariant,
          borderColor: sys.color.supportTwoVariant,
        },
        supportThree: {
          backgroundColor: sys.color.supportThreeVariant,
          textColor: sys.color.supportThreeOnVariant,
          borderColor: sys.color.supportThreeVariant,
        },
        supportFour: {
          backgroundColor: sys.color.supportFourVariant,
          textColor: sys.color.supportFourOnVariant,
          borderColor: sys.color.supportFourVariant,
        },
        supportFive: {
          backgroundColor: sys.color.supportFiveVariant,
          textColor: sys.color.supportFiveOnVariant,
          borderColor: sys.color.supportFiveVariant,
        },
        supportSix: {
          backgroundColor: sys.color.supportSixVariant,
          textColor: sys.color.supportSixOnVariant,
          borderColor: sys.color.supportSixVariant,
        },
      },
    },
  };

  return comp;
};
